<template>
  <div>
    <!-- Alumni Articles -->
    <div class="container">
      <div class="row justify-content-lg-between">
        <div class="col-md-12 g-pt-50 g-pt-100--md g-pb-70">
          <div class="row">
            <!-- Alumni Article -->
            <div class="col-sm-6 g-mb-30">
              <article>
                <a v-on:click="RouterRedirect('Frames')" target="_blank"
                  ><img
                    class="img-fluid mb-4"
                    :src="CNN_Bottom_Left"
                    alt="Image Description"
                /></a>
                <h3 class="h3">Adopt-a-School Today!</h3>
                <p
                  class="g-font-size-18--md g-font-size-17"
                  style="min-height: 100px"
                >
                  OneSight EssilorLuxottica Foundation encourages eye doctors to pledge to Adopt-a-School this year to provide vision care to local students with the support of Changing Life through Lenses® free glasses. Go to the Resources page to get started.
                </p>
                <center>
                  <a
                    class="btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18"
                    href="/Portal/Resources"
                    >Get Started</a
                  >
                </center>
              </article>
            </div>
            <!-- End Alumni Article -->

             <!-- Alumni Article -->
          <div class="col-sm-6 g-mb-30">
            <article>
              <a v-on:click="RouterRedirect('Help')" target="_blank"><img class="img-fluid mb-4" :src="CNN_Top_Right" alt="Image Description"></a>
              <h3 class="h3">The New OneSight EssilorLuxottica Foundation</h3>
              <p class="g-font-size-18--md g-font-size-17" style="min-height: 100px">As the leading global vision care foundation, OneSight EssilorLuxottica Foundation is committed to helping
contribute to eliminating uncorrected poor vision in a generation by creating sustainable access through an innovative approach to impact philanthropy, partnerships and raising awareness.
</p>
              <center>
                <a class="btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18"
                href="https://onesight.essilorluxottica.com/"
                    target="_blank"
                    >Learn More</a>
              </center>
            </article>
          </div>
          <!-- End Alumni Article -->

            <!-- Alumni Article
            <div class="col-sm-6 g-mb-30">
              <article>
                <a
                  href="https://evfusa.org/resources?utm_source=cltl&utm_medium=referral&utm_campaign=od_program"
                  target="_blank"
                  ><img
                    class="img-fluid mb-4"
                    :src="CNN_Bottom_Left"
                    alt="Image Description"
                /></a>
                <h3 class="h3">Marketing Catalog</h3>
                <p
                  class="g-font-size-18--md g-font-size-17"
                  style="min-height: 100px"
                >
                  Doing good is good for business! Access an easy to use guide
                  with press releases, social media posts, and more to promote
                  your charitable work and raise awareness about the cause of
                  vision.
                </p>
                <center>
                  <a
                    class="btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18"
                    href="http://onesight.essilorluxottica.com/"
                    target="_blank"
                    >Learn More</a
                  >
                </center>
              </article>
            </div>
            <!-- End Alumni Article -->

            <!-- Alumni Article
            <div class="col-sm-6 g-mb-30">
              <article>
                <a
                  href="https://drive.google.com/file/d/1KEDMu0_ekEgNNbvcCgrVXyduLfCddXty"
                  target="_blank"
                  ><img
                    class="img-fluid mb-4"
                    height="42"
                    :src="CNN_Bottom_Right"
                    alt="Image Description"
                /></a>
                <h3 class="h3">Vision Charity Basics</h3>
                <p
                  class="g-font-size-18--md g-font-size-17"
                  style="min-height: 100px"
                >
                  Good vision is so important for everyone. Learn more about the
                  fundamentals of charitable vision work and ideas on how to get
                  involved.
                </p>
                <center>
                  <a
                    class="btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18"
                    href="https://drive.google.com/open?id=1KEDMu0_ekEgNNbvcCgrVXyduLfCddXty"
                    target="_blank"
                    >Learn More</a
                  >
                </center>
              </article>
            </div>
            <!-- End Alumni Article -->
          </div>
        </div>
      </div

      <div
        class="col-12 col-md-5 col-lg-4 h-100 g-bg-secondary-gradient-v1 g-pos-abs g-top-0 g-left-0 g-z-index-minus-1"
      ></div>
    </div>
    <!-- End Alumni Articles -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    RouterRedirect(name) {
      var href = window.location.href;
      if (href[href.length - 1] == "/")
        window.open("../" + name + "/", "_blank");
      else window.open(href + "/../" + name + "/", "_blank");
    },
  },
};
</script>



// WEBPACK FOOTER //
// HomePromo.vue?f6ba1696